import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import axios, { API, authed, apiError } from "@/lib/api";

export default function UsersPanel({ getToken }) {
  const [data, setData] = useState(null);
  const load = useCallback(async () => {
    try { setData((await axios.get(`${API}/users`, await authed(getToken))).data); }
    catch (e) { toast.error(apiError(e)); }
  }, [getToken]);
  useEffect(() => { load(); }, [load]);
  const change = async (uid, role) => {
    try { await axios.patch(`${API}/users/${uid}/role`, { role }, await authed(getToken)); toast.success("Rôle mis à jour"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  if (!data) return null;
  return (
    <div className="bg-[#0A1325] border border-white/10 divide-y divide-white/10 max-w-2xl" data-testid="users-panel">
      {data.users.map((u) => (
        <div key={u.user_id} className="flex items-center justify-between gap-4 p-4 text-sm">
          <span className="truncate">{u.email || u.user_id}</span>
          <select value={u.role} onChange={(e) => change(u.user_id, e.target.value)} data-testid={`user-role-select-${u.user_id}`}
            className="bg-[#050B14] border border-white/15 px-3 py-2">
            {data.roles.map((r) => <option key={r} value={r}>{r === "admin" ? "Administrateur" : "Sans accès"}</option>)}
          </select>
        </div>
      ))}
    </div>
  );
}
